import { Component } from '@angular/core';
import {
  OptimizationRunStopsTableComponent
} from "./optimization-run-stops-table/optimization-run-stops-table.component";
import {ActivatedRoute} from "@angular/router";
import {MdbButtonComponent} from "../../../utils/mdb-button/mdb-button.component";

@Component({
  selector: 'app-selected-route',
  imports: [
    OptimizationRunStopsTableComponent,
    MdbButtonComponent
  ],
  templateUrl: './selected-route.component.html',
  styleUrl: './selected-route.component.scss',
})
export class SelectedRouteComponent {
  routeId!: number;

  constructor(
    private activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit () {
    this.routeId = this.activatedRoute.snapshot.params['id'];
  }

  goingBack() {
    window.history.back();
  }
}
